<template>
  <div>
    <page-header slot="header" @submit="handleSubmit" ref="header" />
    <page-main ref="mains" :table-data="table" :loading="loading" @submit="reload" @success="close"/>
    <js-pagination
        class="mt-2"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        align="left"
        @change="handlePaginationChange"
        size="sm"
    />
  </div>
</template>

<script>
export default {
  components: {
    'PageHeader': () => import('./header/index'),
    'PageMain': () => import('./main')
  },
  data () {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      }
    }
  },
  methods: {
    // 分页查询
    handlePaginationChange (val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 重载表格数据
    reload () {
      this.$refs.header.query()
    },
    clearCurrent () {
      this.$refs.mains.setCurrent(null)
    },
    // 加载表格数据
    handleSubmit (form) {
      this.loading = true
      this.$api.projectInfoListApi({
        ...form,
        ...this.page
      }).then(res => {
        this.loading = false
        this.page.pageTotal = res.body.count
        this.table = res.body.data
      }).catch(() => {
        this.loading = false
      })
    },
    close () {
      this.$emit('success')
    },
    save () {
      this.$refs.mains.save()
    }
  }
}
</script>
